import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './selectgame.css';
import trueSound from './assets/true.wav';
import wrongSound from './assets/wrong.wav';
import solveSound from './assets/Solve-Sound.wav';
import countdownSound from './assets/Countdown-15s.wav';
import Swal from 'sweetalert2';
import { db } from '../Firebase';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';

// ตั้งค่า SweetAlert2 ให้แสดงค้างไว้
const Toast = Swal.mixin({
  showConfirmButton: true,
  showDenyButton: false,
  showCancelButton: false,
  showCloseButton: false,
  allowOutsideClick: false,
  allowEscapeKey: false,
  timer: undefined,
  timerProgressBar: false,
  backdrop: true,
  heightAuto: false
});


function SolveGame({ userData, onUserUpdate, visible, onClose }) {
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  // ข้อมูลภาพโจทย์และคำตอบทั้งหมด 50 ข้อ
  const problemSets = [
    { id: 0, image: require('./assets/select-0.jpg'), answer: '2' },
    { id: 1, image: require('./assets/select-1.jpg'), answer: '1' },
    { id: 2, image: require('./assets/select-2.jpg'), answer: '2' },
    { id: 3, image: require('./assets/select-3.jpg'), answer: '1' },
    { id: 4, image: require('./assets/select-4.jpg'), answer: '2' },
    { id: 5, image: require('./assets/select-5.jpg'), answer: '1' },
    { id: 6, image: require('./assets/select-6.jpg'), answer: '1' },
    { id: 7, image: require('./assets/select-7.jpg'), answer: '1' },
    { id: 8, image: require('./assets/select-8.jpg'), answer: '1' },
    { id: 9, image: require('./assets/select-9.jpg'), answer: '1' },
    { id: 10, image: require('./assets/select-10.jpg'), answer: '1' },
    { id: 11, image: require('./assets/select-11.jpg'), answer: '2' },
    { id: 12, image: require('./assets/select-12.jpg'), answer: '1' },
    { id: 13, image: require('./assets/select-13.jpg'), answer: '2' },
    { id: 14, image: require('./assets/select-14.jpg'), answer: '1' },
    { id: 15, image: require('./assets/select-15.jpg'), answer: '1' },
    { id: 16, image: require('./assets/select-16.jpg'), answer: '2' },
    { id: 17, image: require('./assets/select-17.jpg'), answer: '2' },
    { id: 18, image: require('./assets/select-18.jpg'), answer: '2' },
    { id: 19, image: require('./assets/select-19.jpg'), answer: '1' },
    { id: 20, image: require('./assets/select-20.jpg'), answer: '1' },
    { id: 21, image: require('./assets/select-21.jpg'), answer: '2' },
    { id: 22, image: require('./assets/select-22.jpg'), answer: '2' },
    { id: 23, image: require('./assets/select-23.jpg'), answer: '2' },
    { id: 24, image: require('./assets/select-24.jpg'), answer: '2' },
    { id: 25, image: require('./assets/select-25.jpg'), answer: '2' },
    { id: 26, image: require('./assets/select-26.jpg'), answer: '2' },
    { id: 27, image: require('./assets/select-27.jpg'), answer: '1' },
    { id: 28, image: require('./assets/select-28.jpg'), answer: '1' },
    { id: 29, image: require('./assets/select-29.jpg'), answer: '1' },
    { id: 30, image: require('./assets/select-30.jpg'), answer: '2' },
    { id: 31, image: require('./assets/select-31.jpg'), answer: '2' },
    { id: 32, image: require('./assets/select-32.jpg'), answer: '1' },
    { id: 33, image: require('./assets/select-33.jpg'), answer: '1' },
    { id: 34, image: require('./assets/select-34.jpg'), answer: '1' },
    { id: 35, image: require('./assets/select-35.jpg'), answer: '2' },
    { id: 36, image: require('./assets/select-36.jpg'), answer: '1' },
    { id: 37, image: require('./assets/select-37.jpg'), answer: '1' },
    { id: 38, image: require('./assets/select-38.jpg'), answer: '1' },
    { id: 39, image: require('./assets/select-39.jpg'), answer: '2' },
    { id: 40, image: require('./assets/select-40.jpg'), answer: '1' },
    { id: 41, image: require('./assets/select-41.jpg'), answer: '2' },
    { id: 42, image: require('./assets/select-42.jpg'), answer: '1' },
    { id: 43, image: require('./assets/select-43.jpg'), answer: '2' },
    { id: 44, image: require('./assets/select-44.jpg'), answer: '1' },
    { id: 45, image: require('./assets/select-45.jpg'), answer: '2' },
    { id: 46, image: require('./assets/select-46.jpg'), answer: '2' },
    { id: 47, image: require('./assets/select-47.jpg'), answer: '1' },
    { id: 48, image: require('./assets/select-48.jpg'), answer: '1' },
    { id: 49, image: require('./assets/select-49.jpg'), answer: '2' }
  ];

  const [currentProblem, setCurrentProblem] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [score, setScore] = useState(0);
  const [gameStarted, setGameStarted] = useState(false);
  const [timeLeft, setTimeLeft] = useState(15);
  const [gameEnded, setGameEnded] = useState(false);
  const [currentLevel, setCurrentLevel] = useState(0);
  const [infoShown, setInfoShown] = useState(false);

  // Function to safely stop audio
  const stopAudio = () => {
    if (audioRef.current) {
      try {
        // หยุดการเล่นแบบ loop ก่อน
        audioRef.current.loop = false;
        // หยุดเสียง
        audioRef.current.pause();
        // รีเซ็ตเวลา
        audioRef.current.currentTime = 0;
        // ล้าง event listeners
        audioRef.current.onended = null;
        audioRef.current.onerror = null;
        // ล้าง reference
        audioRef.current = null;
        setIsAudioPlaying(false);
      } catch (error) {
      }
    } else {
    }
  };

  // Function to safely play audio
  const playAudio = async (audioSrc, loop = false) => {
    try {
      // Stop any existing audio first
      stopAudio();
      
      // Create new audio instance
      const audio = new Audio(audioSrc);
      
      // Set loop property before playing
      audio.loop = loop;
      
      // Assign ref BEFORE playing to ensure it can be stopped immediately
      audioRef.current = audio;
      setIsAudioPlaying(true);
      
      // Wait for audio to be ready
      await audio.play();
      
      // Handle audio end
      audio.onended = () => {
        if (!loop) {
          setIsAudioPlaying(false);
        }
      };
      
      // Handle audio errors
      audio.onerror = () => {
        setIsAudioPlaying(false);
      };
      
    } catch (error) {
      setIsAudioPlaying(false);
    }
  };

  // ฟังก์ชันสำหรับ update Bonus-Solve เมื่อกดปุ่มเริ่มเกมส์


  // ดึงข้อมูล Solve-Level จาก Database เมื่อเริ่มเกม
  useEffect(() => {
    if (visible && !gameStarted) {
      getCurrentSolveLevel();
    }
  }, [visible, gameStarted]);

  const getCurrentSolveLevel = async () => {
    if (userData?.username) {
      try {
        const userRef = doc(db, "P1", userData.username);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          const userData = docSnap.data();
          const selectLevel = userData.selectlevel || 0;
          setCurrentLevel(selectLevel);
          
          // ตั้งค่าคำถามตามระดับปัจจุบัน
          setCurrentProblem(selectLevel);
        }
      } catch (error) {
        console.error("Error getting Select-Level:", error);
        setCurrentLevel(0);
        setCurrentProblem(0);
      }
    }
  };

  // แสดง information เมื่อเริ่มต้น
  useEffect(() => {
    if (visible && !gameStarted && currentLevel >= 0 && !infoShown) {
      // เล่นเสียง Solve-Sound.wav แบบวนไปเรื่อยๆ
      playAudio(solveSound, true);
      
      Toast.fire({
        title: '🏆 Match Picture',
        html: `
          <div style="text-align: left; margin: 20px 0;">
            <h3 style="color: #2c3e50; margin-bottom: 15px; margin-left: 18px;">📋 กติกาการเล่น:</h3>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• ดูภาพโจทย์และหาคำตอบที่ถูกต้อง</p>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• เลือกคำตอบที่ถูกต้อง (กดเลือกที่รูปภาพ)</p>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• เวลาในการทำ: 15 วินาที</p>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• ตอบถูกจะได้ 50 คะแนน</p>
          </div>
        `,
        icon: 'info',
        showCancelButton: false,
        confirmButtonText: '🎮 เริ่มเกม!',
        confirmButtonColor: '#28a745',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false
      }).then(async (result) => {
        if (result.isConfirmed) {
          // หยุดเสียงเมื่อเริ่มเกม
          stopAudio();
          

          
          setGameStarted(true);
          setTimeLeft(15);
          // เล่นเสียง countdown เมื่อเริ่มเกม
          playAudio(countdownSound);
        }
      });
      
      // Mark info as shown to prevent it from showing again
      setInfoShown(true);
    }
  }, [visible, gameStarted, currentLevel, infoShown]);

  // Timer countdown
  useEffect(() => {
    if (gameStarted && timeLeft > 0 && !gameEnded) {
      const timer = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (timeLeft === 0 && !gameEnded) {
      // เมื่อเวลาหมด ให้แสดงว่าตอบผิด
      setGameEnded(true);
      playAudio(wrongSound);
      
      Toast.fire({
        title: '⏰ เวลาหมด!',
        html: `
          <div style="text-align: center; margin: 20px 0;">
            <p style="font-size: 18px; color: #e74c3c;">เวลาหมดแล้ว</p>
            <p style="font-size: 20px; font-weight: bold; color: #2c3e50;">คะแนนที่ได้: <span style="color: #e74c3c;">0 คะแนน</span></p>
          </div>
        `,
        icon: 'warning',
        confirmButtonText: 'ตกลง',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false
      }).then(() => {
        // บันทึกคะแนนและออกจากโปรแกรมไปหน้า Exercises
        saveScoreAndNavigate(0);
      });
    }
  }, [gameStarted, timeLeft, gameEnded, currentLevel]);

  const handleAnswer = (selectedOption) => {
    // ป้องกันการเรียกซ้ำ
    if (gameEnded) return;
    
    // หยุด timer ทันทีเมื่อตอบคำถาม
    setGameEnded(true);
    
    // Use selectedOption if provided (from click), otherwise use userAnswer (backup)
    const answer = selectedOption ? selectedOption.toString() : userAnswer;
    
    // Capture current time left for score calculation
    const currentTimeLeft = timeLeft;

    if (answer.trim() === problemSets[currentProblem].answer) {
      playAudio(trueSound);
      
      const finalScore = 50; // คะแนนที่ได้เมื่อตอบถูก (Updated to 50 as per rules)
      setScore(finalScore);
      
      // ใช้ setTimeout เพื่อให้แน่ใจว่า state ได้อัปเดตแล้ว
      setTimeout(() => {
        Toast.fire({
          title: '🎉 ถูกต้อง!',
          html: `
            <div style="text-align: center; margin: 20px 0;">
              <p style="font-size: 18px; color: #27ae60;">ยินดีด้วย! คุณตอบถูก</p>
              <p style="font-size: 20px; font-weight: bold; color: #2c3e50;">คะแนนที่ได้: <span style="color: #e74c3c;">${finalScore} คะแนน</span></p>
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'ตกลง',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
          focusConfirm: true,
          returnFocus: false
        }).then((result) => {
          // บันทึกคะแนนและออกจากโปรแกรมไปหน้า Exercises
          // ส่ง true ว่าตอบถูก และส่งเวลาที่เหลือไปคำนวณ speed
          saveScoreAndNavigate(finalScore, true, currentTimeLeft);
        });
      }, 100);
    } else {
      playAudio(wrongSound);
      
      // ใช้ setTimeout เพื่อให้แน่ใจว่า state ได้อัปเดตแล้ว
      setTimeout(() => {
        Toast.fire({
          title: '❌ ผิด!',
          html: `
            <div style="text-align: center; margin: 20px 0;">
              <p style="font-size: 18px; color: #e74c3c;">คำตอบไม่ถูกต้อง</p>
              <p style="font-size: 20px; font-weight: bold; color: #2c3e50;">คะแนนที่ได้: <span style="color: #e74c3c;">0 คะแนน</span></p>
            </div>
          `,
          icon: 'error',
          confirmButtonText: 'ตกลง',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
          focusConfirm: true,
          returnFocus: false
        }).then(() => {
          // ออกจากโปรแกรมไปหน้า Exercises
          saveScoreAndNavigate(0, false, 0);
        });
      }, 100);
    }
  };

  const saveScoreAndNavigate = async (finalScore, isCorrect = false, remainingTime = 0) => {
    // บันทึกคะแนนและเพิ่ม Solve-Level
    if (userData?.username) {
      try {
        const userRef = doc(db, "P1", userData.username);
        const docSnap = await getDoc(userRef);

        let currentSelectLevel = 0;
        if (docSnap.exists()) {
          const currentData = docSnap.data();
          const newScore = (currentData.score || 0) + finalScore;
          currentSelectLevel = currentData.selectlevel || 0;
          
          // เพิ่ม selectlevel + 1 และตรวจสอบเงื่อนไข reset
          let newSelectLevel = currentSelectLevel + 1;
          if (newSelectLevel >= 50) {
            newSelectLevel = 0;
          }

          // Prepare update data
          const updateData = {
            score: newScore,
            selectlevel: newSelectLevel,
            'step3-total': (currentData['step3-total'] || 0) + 1 // 1. เมื่อเล่นจบ step3-total + 1
          };

          if (isCorrect) {
            // 2. เมื่อตอบถูก step3 + 1
            updateData['step3'] = (currentData['step3'] || 0) + 1;

            // 3. เมื่อตอบถูก คำนวณ step3-speed
            // speed = (step3-speed + (เวลาที่เหลือ / 15)*100)/2
            // ถ้า step3-speed เป็น 0 ให้บันทึก (เวลาที่เหลือ / 15)*100 เลย
            const currentSpeed = currentData['step3-speed'] || 0;
            const newSpeedVal = (remainingTime / 15) * 100;
            
            if (currentSpeed === 0) {
              updateData['step3-speed'] = newSpeedVal;
            } else {
              updateData['step3-speed'] = (currentSpeed + newSpeedVal) / 2;
            }
          }

          // อัปเดตข้อมูลใน P1
          await updateDoc(userRef, updateData);
        }
      } catch (error) {
        console.error("Error updating user data:", error);
      }
    }

    // หยุดเสียงก่อนปิดเกม
    stopAudio();
    
    // Reset info shown flag for next time
    setInfoShown(false);
    
    // ปิดเกมและออกจากโปรแกรม
    onClose();
  };

  /*
   * ฟังก์ชัน endGame และ handleBackToExercies ไม่ได้ถูกเรียกใช้ในการไหลของเกมปกติ
   * แต่จะทำการ update ให้ชี้ไปที่ P1 ด้วยเพื่อความสม่ำเสมอหากมีการเรียกใช้ในอนาคต
   */




  // Cleanup audio when component unmounts or when closing
  useEffect(() => {
    return () => {
      stopAudio();
    };
  }, []);

  if (!visible) return null;

  if (!gameStarted) return null;

  return (
    <div className="solve-game-modal">
      <div className="solve-game-content">
        <div className="game-header">
           <h2>Match Picture</h2>
        </div>

        <div className="problem-container">
          <div className="problem-image">
            {/* Clickable Overlay for Option 1 */}
            <div 
              className="answer-overlay option-1" 
              onClick={() => handleAnswer('1')}
            ></div>

            {/* Clickable Overlay for Option 2 */}
            <div 
              className="answer-overlay option-2" 
              onClick={() => handleAnswer('2')}
            ></div>

            <img 
              src={problemSets[currentProblem].image} 
              alt={`Problem ${currentProblem + 1}`}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
 
          <div className="answer-section">
             <div className="time-display" style={{ 
                margin: '10px auto', 
                color: '#333', 
                background: '#f0f0f0', 
                border: '1px solid #ccc',
                display: 'inline-block' 
             }}>
                ⏰ เวลาเหลือ: {timeLeft} วินาที
             </div>
          </div>
        </div>

        {/* Duplicate block removed */}
        </div>
      </div>
  );
}

export default SolveGame;
